<template>
<CModal @mtdclosemodal="mtdclosemodal" :show.sync="boo_modal" :close-on-backdrop="false" :centered="true" :title="title" :size="'xl'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
    <div>
        <div class="inputs px-3 pt-2 border border-1 rounded rounded-2  mt-2" 
        v-for="(bill,index) in bills" :key="index">
            <h6> Factura {{ index+ 1 }}</h6>
            <div class="row d-flex w-100">
                <div :class="'mb-3 col-lg-2 col-md-6'">
                    <label for="staticEmail" class="col-form-label">N° de Factura</label>
                    <input v-model="bill.number" type="text"  placeholder="Ingrese N° de factura" class="form-control  form-control-sm" id="staticEmail" :disabled="bill.state_add ==1" >
                </div>
                <div :class=" 'mb-3 col-lg-3 col-md-6'">
                    <label for="total" class=" col-form-label">Fecha de la Factura</label>
                    <input v-model="bill.date" type="date" class="form-control form-control-sm " id="total"   :disabled="bill.state_add ==1">
                </div>
                <div class="mb-3 col-lg-3 col-md-6" >
                    <label for="exampleFormControlInput11" class="col-form-label">Fecha de vencimiento</label>
                    <input v-model="bill.due_date" type="date" class="form-control form-control-sm" id="exampleFormControlInput11" :disabled="bill.state_add ==1" >
                </div>
                <div v-if="bill.state_add !=1  " class="mb-3 col-lg-4 col-md-6">
                    <label class="col-form-label">Subir Archivo (PDF/Imagen)</label>
                    <input type="file" class="form-control form-control-sm" @change="handleFileUpload($event, index)">
                </div>
                <div v-else class="mb-3 col-lg-4 col-md-6">
                   
                    <div v-if="bill.file">
                        <label class="col-form-label">Ver pdf o imagen</label>
                         <div>
                             <button
                                    class="  btn btn-sm btn-info text-center px-2 py-2"
                                    title="PDF COMPRA"
                                    href="javascript:void(0)"
                                    @click="viewPdf(bill.file)"
                                    style="margin-left: 2px"
                                >
                                    <i class="fas fa-file-pdf text-white"></i>
                            </button>


                         </div>

                    </div>
                     
                        
                </div>
            </div>    
        </div>
        <div class="d-flex justify-content-end mt-3">
                <button  @click="mtdaaddbills"   type="button" class=" border-0 rounded-2 bg-main px-5 py-2 text-white" id="btn-guardar" >GUARDAR</button>
        </div>
    </div>

</CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import CButtonClose from "@/components/shared/modals/cButtonClose.vue";
import {
    mapActions
} from "vuex";

export default {
    name: "c-vigilancia-modal-control",
    components: {
        CModal,
        CButtonClose,
    },
    data() {
        return {
            

        };
    },
    
    props: {
        title: String,
        boo_modal: Boolean,
        bills:Array
    },

    computed: {
       
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdaaddbills:function(){
            let formData = new FormData();
            this.bills.forEach((bill, index) => {
                if(bill.state_add == 0){
                    formData.append(`bills[${index}][id]`, bill.id);
                    formData.append(`bills[${index}][number]`, bill.number || '');
                    formData.append(`bills[${index}][date]`, bill.date ? bill.date : '');
                    formData.append(`bills[${index}][due_date]`, bill.due_date ? bill.due_date : '');
                    formData.append(`bills[${index}][file]`, bill.file);
                }
            });
            this.post({
                url: this.$store.getters.get__url + "/ordendecompra/addfacturas",
                token: this.$store.getters.get__token,
                params:formData
                })
                .then((response) => {
                    
                   this.mtdclosemodal();
                   this.$emit('addbills')
                   Swal.fire({
                        title: "Registro exitoso",
                        text: "Las facturas se han guardado correctamente.",
                        icon: "success",
                        confirmButtonText: "Aceptar"
                    });
                    
                })
                .catch((errors) => {});
        },
        
        mtdclosemodal() {
            this.$emit("closeModalStoreFact");
        },
        handleFileUpload(event, index) {
        const file = event.target.files[0];
            if (file) {
                    const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
                    
                    if (!allowedTypes.includes(file.type)) {
                        Swal.fire({
                            icon: "error",
                            title: "Archivo no válido",
                            text: "Solo se permiten archivos PDF, JPG o PNG.",
                            confirmButtonColor: "#d33"
                        });

                        this.bills[index].file = null;
                        event.target.value = ""; 
                    } else {
                        this.bills[index].file = file;
                        
                    }
                }
        },
        viewPdf: function (ruta) {
            window.open("https://clinicabm.v2.howertpi.com/assets/" + ruta, "_blank");
        },
    },
};
</script>

